module.exports = "/images/sell-party-and-group-sales.svg?2db04e8286a4027d4456212c27c21022";